import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";
import { Button } from "../components/ui/button";
import { Wordmark } from "../components/Wordmark";
import { brandVars } from "../lib/brand";
import { Copy, MessageSquare, Share2, Link2, Loader2, AlertCircle, Building2, Check } from "lucide-react";

const pub = axios.create({ baseURL: API });

export default function ShareKit() {
  const { slug } = useParams();
  const [k, setK] = useState(null);
  const [err, setErr] = useState("");
  const [done, setDone] = useState("");
  useEffect(() => { pub.get(`/public/agency/${slug}/share`).then((r) => setK(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Not available.")); }, [slug]);

  if (err) return <div className="flex min-h-screen items-center justify-center bg-background p-4"><div className="max-w-sm rounded-[2rem] border border-border bg-card p-8 text-center"><AlertCircle className="mx-auto mb-3 h-10 w-10 text-amber-500" /><p className="font-semibold">{err}</p></div></div>;
  if (!k) return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;

  const flash = (what) => { setDone(what); setTimeout(() => setDone(""), 1500); };
  const copy = (t, what) => { navigator.clipboard.writeText(t); flash(what); };
  const share = async () => { if (navigator.share) { try { await navigator.share({ title: `${k.company.display_name} — Consent for Services`, text: k.message, url: k.url }); } catch {} } else copy(k.message, "message"); };
  const b = k.company;

  return (
    <div className="min-h-screen bg-background" style={brandVars(b.primary_color)}>
      <div className="mx-auto flex min-h-screen max-w-lg flex-col px-4 py-6">
        <div className="flex items-center gap-3">
          {b.logo ? <img src={b.logo} alt="" className="h-12 w-12 rounded-xl object-contain" /> : <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white"><Building2 className="h-6 w-6" /></span>}
          <div><p className="font-head text-xl font-extrabold leading-tight">{b.display_name}</p><p className="text-xs text-muted-foreground">Counselor share kit · Consent for Services</p></div>
        </div>
        <div className="mt-6 flex flex-col items-center rounded-[2rem] border border-border bg-card p-6">
          <img src={k.qr_data_url} alt="QR" className="w-full max-w-[260px] rounded-2xl" data-testid="share-qr" />
          <p className="mt-3 text-center text-sm text-muted-foreground">Have the client scan this with their phone camera.</p>
        </div>
        <div className="mt-4 grid gap-3">
          <Button className="h-14 rounded-full text-base" onClick={share} data-testid="share-native"><Share2 className="mr-2 h-5 w-5" /> Share with client</Button>
          <Button asChild variant="outline" className="h-14 rounded-full text-base"><a href={`sms:?&body=${encodeURIComponent(k.message)}`} data-testid="share-sms"><MessageSquare className="mr-2 h-5 w-5" /> Send as text message</a></Button>
          <Button variant="outline" className="h-14 rounded-full text-base" onClick={() => copy(k.message, "message")} data-testid="share-copy-message">{done === "message" ? <Check className="mr-2 h-5 w-5" /> : <Copy className="mr-2 h-5 w-5" />} {done === "message" ? "Copied" : "Copy ready-to-send text"}</Button>
          <Button variant="ghost" className="h-12 rounded-full" onClick={() => copy(k.url, "url")} data-testid="share-copy-link">{done === "url" ? <Check className="mr-2 h-4 w-4" /> : <Link2 className="mr-2 h-4 w-4" />} {done === "url" ? "Copied" : "Copy link only"}</Button>
        </div>
        <p className="mt-3 break-all text-center font-mono text-xs text-muted-foreground" data-testid="share-url">{k.url}</p>
        <p className="mt-auto pt-6 text-center text-xs text-muted-foreground">Powered by <Wordmark className="text-xs" /></p>
      </div>
    </div>
  );
}
